import PlaneAction from "./PlaneAction.js";
import {formatTime} from "../../assets/common/format-utils.js";

export default class Wait extends PlaneAction {
    constructor(planeId, time, description) {
        super(planeId);
        this.time = time;
        this.description = description;
    }

    execute() {
        if (!this.isComplete()) {
            this.log(`Waiting ${this.description} at ${formatTime(this.time)}`);
        }
    }

    isComplete() {
        const simState = this.getSimState();
        return this.time <= simState.time;
    }
}